export const transpilerCache: Map<string, any> = new Map();
